import { graphql } from '@/generated/gql';

export const NEGOTIATION_QUOTE_DETAILS_QUERY = graphql(/* GraphQL */ `
  query NegotiationQuoteDetails($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        isMaskedBidding
        status
        processStatus
        options {
          id
          quoteMode
        }
        quote {
          id
          supplierReference
          currency
          totalValue
          paymentTerms {
            daysToPayment
            discount
          }
          lineItems {
            id
            position
            quantity
            title
            description
            pricePerUnit
            unitId
            totalValue
            shipmentTerms {
              earlyDeliveryAt
              lateDeliveryAt
            }
            deliveryLocationId
            organizationId
            commodityId
            status
          }
        }
      }
    }
  }
`);
